import React from 'react';
import ConfirmationModal from '../ConfirmationModal';
import { formatRand } from '@/utility/helper';

interface ProcessRefundModalProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onConfirm: (refundAmount: string) => void;
    status: string;
    requestedRefundAmount: string;
    loading: boolean;
}

export const ProcessRefundModal: React.FC<ProcessRefundModalProps> = ({
    open,
    onOpenChange,
    onConfirm,
    status,
    requestedRefundAmount,
    loading,
}) => {
    const isPendingReview = status === 'pending_review';

    return (
        <ConfirmationModal
            open={open}
            onOpenChange={onOpenChange}
            onConfirm={() => onConfirm(requestedRefundAmount)}
            title={isPendingReview ? "Approve Return Request" : "Process Customer Refund"}
            message={isPendingReview
                ? "Are you sure you want to approve this return request immediately? This will update the return status to Approved and advance the flow."
                : "Are you sure you want to process the refund for this returned order? This will complete the pickup refund flow."
            }
            confirmText={isPendingReview ? "Confirm Approval" : "Complete Refund"}
            cancelText="Cancel"
            loading={loading}
            type="success"
            size="lg"
        >
            <div className="mt-4 text-center">
                <p className="text-sm font-semibold text-muted-foreground mb-1">Refund Amount</p>
                <p className="text-3xl font-black text-primary">{formatRand(Number(requestedRefundAmount || 0))}</p>
            </div>
        </ConfirmationModal>
    );
};
